
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { useAuthDispatch, useAuthState } from '../../../../../Helper/Context'
import { BaseUrl } from '../../../../../Helper/BaseUrl'
import { toastErrorr, toastSuccesss } from '../../../../../Helper/ToastMessage'

const OTPModal = (props) => {
    const { MobileNo, setReturnID, OTP_Action, handlePostAPI, handleOTPSubmit, cancelbtn, TokenData, loadingOTPSubmit, isForgotPassword, onVerifySuccess } = props

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const authDispatch = useAuthDispatch()

    const userDetails = useAuthState();
    const { UserID, token, MobileNumber } = userDetails.user

    const [OtpError, setOtpError] = useState("")
    const inputRefs = useRef([]);
    const [otp, setOtp] = useState(['', '', '', ''])
    const [loading, setloading] = useState(false)
    const [OTPMsg, setOTPMsg] = useState('')
    const [timer, setTimer] = useState(60); // Timer for resend OTP

    useEffect(() => {
        let interval;
        if (timer > 0) {
            interval = setInterval(() => {
                setTimer((prev) => prev - 1);
            }, 1000);
        }
        return () => clearInterval(interval);
    }, [timer]);

    const [FCMToken, setFcmToken] = useState(null);

    useEffect(() => {
        handleSendOtp('Submit_MobileOTP', '')
    }, []);

    const handleSendOtp = (Flag, Mobile_OTP) => {
        const formdata = new FormData();
        formdata.append("MobileNumber", MobileNumber ?? '');
        formdata.append("Mobile_OTP", Mobile_OTP);
        formdata.append("Flag", Flag);
        formdata.append("OTP_Action", OTP_Action);
        formdata.append("M_UserID", UserID);

        const requestOptions = {
            method: "POST",
            body: formdata,
            redirect: "follow"
        };

        fetch(`${BaseUrl}/Electrical/M_UserWiseOTP_Submit_Verify`, requestOptions)
            .then((response) => response.json())
            .then((result) => {
                if (result?.status && result?.message == "Vaild OTP" && Flag == "Verify_MobileOTP") {
                    handlePostAPI()
                } else if (result?.status && result?.message == "OTP Send Successfully" && Flag == "Submit_MobileOTP") {
                  toastSuccesss(result?.message)
                }
                else {
                    toastErrorr(result?.message)
                }
            })
            .catch((error) => console.error(error));
    }

    // Auto-focus first input when modal opens
    useEffect(() => {
        // Small delay to ensure DOM is ready
        const timer = setTimeout(() => {
            if (inputRefs.current[0]) {
                inputRefs.current[0].focus();
            }
        }, 100);

        return () => clearTimeout(timer);
    }, []);

    // otp
    const handleChange = (e, index) => {
        const { value } = e.target;
        if (value && !/^\d{0,1}$/.test(value)) {
            return;
        }

        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);

        if (value && index < otp.length - 1) {
            inputRefs.current[index + 1].focus();
        }
    };

    //otp
    const handleKeyDown = (e, index) => {
        if (e.key === 'Enter') {
            handleVerifyOTP();
        }

        if (e.key === 'Backspace' && !otp[index] && index > 0) {
            inputRefs.current[index - 1].focus();
        }

        if (e.key === 'ArrowLeft' && index > 0) {
            inputRefs.current[index - 1].focus();
        }

        // Handle right arrow key
        if (e.key === 'ArrowRight' && index < otp.length - 1) {
            inputRefs.current[index + 1].focus();
        }
    };

    //otp
    const handlePaste = (e) => {
        e.preventDefault();
        const pastedData = e.clipboardData.getData('text');
        const digits = pastedData.replace(/\D/g, '').split('').slice(0, otp.length);

        if (digits.length) {
            const newOtp = [...otp];
            digits.forEach((digit, idx) => {
                if (idx < otp.length) {
                    newOtp[idx] = digit;
                }
            });
            setOtp(newOtp);

            const focusIndex = Math.min(digits.length, otp.length - 1);
            inputRefs.current[focusIndex].focus();
        }
    };

    const handleVerifyOTP = () => {
        const otpValue = otp.join('');
        if (otpValue.length == 4) {
            handleSendOtp('Verify_MobileOTP', otpValue,)
        } else {
            setOtpError("Please enter a valid 4-digit OTP");
        }
    }

    const handleIsPost = (res, id) => {
        if (res && res == "Vaild OTP") {
            if (isForgotPassword) {
                onVerifySuccess();
            } else {
                // verifyOTPContext(authDispatch, TokenData, FCMToken)
                // console.log("success")
                navigate(`/Dashboard`)
            }
        } else {
            setOTPMsg(res?.message)
            console.log("error")
        }
        setloading(false)
    }

    const [ResendLoader, setResendLoader] = useState(false)
    const handleResendOtp = () => {
        if (timer > 0) return;
        // setOTPSent(false)
        setResendLoader(true)
        setOTPMsg('')
        setOtp(['', '', '', '',])
        handleOTPSubmit(UserID, token || TokenData?.access_token, TokenData?.Email || '', 'Submit_EmailOTP')
        console.log("log");

        // Re-focus first input after resend
        setTimeout(() => {
            if (inputRefs.current[0]) {
                inputRefs.current[0].focus();
            }
            setResendLoader(false)
            setTimer(60);
        }, 100);
    }

    return (
        <>
            <div className="modal fade show rounded" style={{ display: "flex", alignItems: 'center', backgroundColor: "#00000090" }}>
                <div className="modal-dialog modal-md" role="document">
                    <div className="modal-content">
                        {/* <button onClick={() => cancelbtn()} type="button" className="close" style={{ marginLeft: "auto" }}>
                            <span aria-hidden="true" className="cancel_btn rounded opacity-100">&times;</span>
                        </button> */}

                        <div className="modal-header pl-4 p-1" style={{ background: 'white' }}>
                            <h5 className="modal-title" id="staticBackdropLabel"></h5>
                            <button onClick={cancelbtn} className="btn-close m-1 mr-3" type="button" />
                        </div>

                        {/* { loadingOTPSubmit && <LogoLoader />} */}
                        <div className="modal-body mx-5">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="row verification pt-0 text-center">
                                        <div className="col-md-12 text-center d-flex flex-column">
                                            <p className='text-black mb-1' style={{ fontWeight: 'normal' }}>
                                                We have sent a verification code to your Mobile No. </p>
                                            <h5 className='fs-4 text-black mb-1 fw-bold'>
                                                {MobileNumber ?? ''}
                                            </h5>
                                        </div>
                                        <div className="col-12 form-group my-2 d-flex align-items-center text-center justify-content-center">
                                            <label htmlFor="otp" className='text-center text-black' id="six_digit" style={{ fontSize: "14px" }}>Enter 4 Digit Code</label>
                                        </div>

                                        <div className="col-12 divcenter">
                                            {otp.map((digit, index) => (
                                                <input
                                                    key={index}
                                                    type="text"
                                                    className="form-control otpBox border-green2 text-center fs-5 p-0 p-lg-2 mr-2"
                                                    value={digit}
                                                    onChange={(e) => handleChange(e, index)}
                                                    onKeyDown={(e) => handleKeyDown(e, index)}
                                                    onPaste={index == 0 ? handlePaste : null}
                                                    maxLength={1}
                                                    ref={el => inputRefs.current[index] = el}
                                                    autoComplete="off"
                                                />
                                            ))}
                                        </div>

                                        <div className="col-12 mt-1 d-flex flex-lg-row flex-column mt-4 justify-content-between align-items-center ">
                                            <p className="mb-0 text-black" style={{ fontSize: "14px" }}>Haven't received you OTP yet ?</p>
                                            <p className="mb-0 pe-2 text-primary"
                                                style={{ fontSize: "14px", cursor: timer > 0 ? "not-allowed" : "pointer", color: timer > 0 ? "gray" : "" }} role="button"
                                                onClick={() => timer > 0 ? '' : handleSendOtp('Submit_MobileOTP', '')}>
                                                {
                                                    ResendLoader ? <i className="fa fa-spinner fa-spin" aria-hidden="true"></i> :
                                                        (timer > 0 ? `Resend in ${timer}s` : "Resend OTP")
                                                }
                                            </p>
                                        </div>

                                        <div className="col-12 d-flex justify-content-center align-items-center mt-3 mb-3">
                                            <button
                                                disabled={loading}
                                                type="button"
                                                className="btn btn_submit text-white form-control col-4"
                                                style={{ backgroundColor: '#048A8B' }}
                                                onClick={handleVerifyOTP}
                                            >
                                                {loading && (
                                                    <i
                                                        className="fa fa-spinner fa-spin"
                                                        style={{ marginRight: "5px" }}
                                                    />
                                                )}
                                                {!loading && <span>Verify OTP</span>}
                                            </button>
                                        </div>

                                        {OTPMsg && <p className='text-danger ps-3 mb-1 px-0' style={{ fontSize: '15px', marginTop: '-5px' }}>{OTPMsg}</p>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default OTPModal